import React, { useEffect, useState } from "react";
import {GetLanguages} from "../../../../../../../core/Services";
import { useAuth } from "../../../../../../../auth/core/AuthContext";

export default function LanguagesTable() {
  const [languages, setLanguages] = useState([]);
  const {userData} = useAuth();

   const browser = [
     { value: "0", label: "Google" },
     { value: "1", label: "Yandex" },
     { value: "2", label: "Diğer" },
   ];

   const months = [
     { name: "Ocak", value: "01" },
     { name: "Şubat", value: "02" },
     { name: "Mart", value: "03" },
     { name: "Nisan", value: "04" },
     { name: "Mayıs", value: "05" },
     { name: "Haziran", value: "06" },
     { name: "Temmuz", value: "07" },
     { name: "Ağustos", value: "08" },
     { name: "Eylül", value: "09" },
     { name: "Ekim", value: "10" },
     { name: "Kasım", value: "11" },
     { name: "Aralık", value: "12" },
   ];
  useEffect(() => {
    GetLanguages(userData?.unique_id)
      .then((data) => {
        setLanguages(data.data);
      })
      .catch((error) => {
        console.log("Ülke Veri Çekme Hatası", error);
      });
  }, [userData?.unique_id]);


  return (
    <div>
      <table
        style={{
          fontFamily: "arial, sans-serif",
          borderCollapse: "collapse",
          width: "80%",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            ></th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Dönem
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Platform
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Diller
            </th>
            <th
              style={{
                border: "1px solid #dddddd",
                textAlign: "left",
                padding: "8px",
              }}
            >
              Kullanıcılar
            </th>
          </tr>
        </thead>
        <tbody>
          {languages &&
            languages?.map((lang, index) => (
              <tr
                key={lang.id}
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "left",
                  padding: "8px",
                }}
              >
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {index + 1}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {months?.find((months) => months.value === lang.month)
                    ?.name || ""}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {browser?.find((bro) => bro.value === lang.platform)?.label ||
                    ""}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {lang?.languages}
                </td>
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "left",
                    padding: "8px",
                  }}
                >
                  {lang?.visitor}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
